<section id="faq" class="bg-canvas/60 py-24 lg:py-32">
  <div class="site-container">
    <div class="mx-auto max-w-3xl">
      <h2 class="mb-16 text-center text-3xl font-bold lg:text-4xl">{{ content.title }}</h2>
      <div class="space-y-4">
        @for (item of content.items; track item.question; let first = $first) {
          <details class="group border-b border-line pb-4" [open]="first">
            <summary
              class="flex cursor-pointer list-none items-center justify-between gap-4 text-lg font-bold text-primary [&::-webkit-details-marker]:hidden"
            >
              {{ item.question }}
              <app-icon name="expand_more" class="transition-transform group-open:rotate-180" />
            </summary>
            <p class="mt-4 leading-relaxed text-muted">{{ item.answer }}</p>
          </details>
        }
      </div>
    </div>
  </div>
</section>
